import React from "react";
import { connect } from "react-redux";
//import logo from '../../assets/images/horizontal-enterprise2.png'
import logo from "../../assets/images/logo_long_light.png";
import CircularProgress from "@material-ui/core/CircularProgress";
import { openSnackBar } from "../../actions/snack-bar";
import { magicLink } from "../../actions/authentication";
import { setVisibility } from "../../actions/message-drawer";
import styles from "./styles";
import { compose } from "recompose";
import LoadingButton from "../../components/LoadingButton";
import {
  withStyles,
  Button,
  TextField,
  Typography,
  Card,
  CardContent,
  CardActions,
  Checkbox,
} from "@material-ui/core";

class MagicLink extends React.Component {
  sendMagic = () => {
    const user = this.props.authentication.authenticatedUser;
      console.log(user);
      console.log("+" + user.phone.replace(/\D/g, ""));
    this.props.dispatch(magicLink("+" + user.phone.replace(/\D/g, "")));
    this.props.dispatch(
      openSnackBar({
        message: "Sent! Now logging out and redirecting you home.",
      })
    );
    this.props.dispatch({ type: "LOGOUT" });
    localStorage.clear();
    setTimeout(function () {
      window.location.assign("https://www.google.com/");
    }, 10000);
  };

  sendHome = () => {
    this.props.dispatch(
      openSnackBar({ message: "Now logging out and redirecting you home." })
    );
    this.props.dispatch({ type: "LOGOUT" });
    localStorage.clear();
    setTimeout(function () {
      window.location.assign("https://www.google.com/");
    }, 3000);
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.wrapper}>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <div>
          <img
            src={logo}
            alt="SafeShowing Logo"
            className={classes.logoImage}
          />
        </div>
        <Typography variant="h6" align="center" style={{ margin: "25px" }}>
          {`All done! Click the button below and we will send you a code to download our app. Thank you for using SafeShowings Enterprise!`}
        </Typography>
        <LoadingButton
          color="primary"
          className={classes.buttonReg}
          onClick={this.sendMagic}
          type="submit"
          style={{ padding: "13px 30px", fontSize: "large" }}
        >
          Send Link
        </LoadingButton>
        <Button color="primary" onClick={this.sendHome} type="submit">
          Go Home
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ authentication: state.authentication });

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true })
)(MagicLink);
